<template>
  <div class="orders-view">
    <h2>Мои заказы</h2>
    
    <el-table
      v-loading="loading"
      :data="orders"
      style="width: 100%"
      empty-text="Нет заказов"
    >
      <el-table-column prop="order_number" label="ID заказа" width="100" >
        <template #default="{ row }">
          {{ row.order_number + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="currency" label="Валюта" width="100" />
      <el-table-column prop="amount" label="Сумма" width="120">
        <template #default="{ row }">
          {{ row.amount?.toFixed(4) || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="sender.name" label="Отправитель" />
      <el-table-column prop="payee.name" label="Получатель" />
      <el-table-column prop="status_ru" label="Статус" width="80" />
      <el-table-column prop="created_at" label="Дата создания" width="180">
        <template #default="{ row }">
          {{ formatDate(row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column label="Действия" width="80">
        <template #default="{ row }">
          <el-button
            type="primary"
            icon="Edit"
            circle
            size="small"
            @click="editOrder(row)"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { Order } from '@/store/types'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'OrdersView',
  setup() {
    const store = useStore()
    const router = useRouter()
    const orders = computed(() => [...store.state.orders].sort((a: Order, b: Order) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()))
    const loading = computed(() => store.state.loading)

    const getStatusType = (status: string) => {
      const types: Record<string, string> = {
        pending: 'warning',
        completed: 'success',
        failed: 'danger'
      }
      return types[status] || 'info'
    }

    const formatDate = (date: string) => {
      return new Date(date).toLocaleString()
    }

    const editOrder = (order: Order) => {
      store.commit('SET_CURRENT_ORDER', order)
      router.push(`/order/${order.id}`)
    }

    onMounted(async () => {
      try {
        await store.dispatch('fetchOrders')
      } catch (error) {
        ElMessage.error('Failed to load orders')
      }
    })

    return {
      orders,
      loading,
      getStatusType,
      formatDate,
      editOrder
    }
  }
})
</script>

<style lang="scss" scoped>
.orders-view {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;

  h2 {
    margin-bottom: 20px;
  }
}

@media (max-width: 768px) {
  .orders-view {
    padding: 10px;
  }
}
</style> 